import gql from "graphql-tag";
import { handleMutationResult } from "~/core/store/common/errors/handleStoreError.ts";
export const state = () => ({
  zones: {
    content: []
  }
});
export const getters = {
  zones(state) {
    return state.zones;
  }

};
export const mutations = {
  setZones(state, payload) {
    state.zones = payload;
  }

};
export const actions = {
  async zones(_ref, zoneData) {
    let {
      commit,
      dispatch,
      rootGetters
    } = _ref;
    await dispatch("apollo/query", {
      query: gql`
          query($page: Int, $size: Int, $country_id: String) {
            zonesList(page: $page, size: $size, country_id: $country_id) {
              content {
                id
                name
              }
              totalPages
              totalElements
              first
              last
              number
              numberOfElements
            }
          }
        `,
      variables: zoneData
    }, {
      root: true
    });

    if (
      handleMutationResult({ commit, rootGetters }, { showNotification: true })
    ) {
      commit("setZones", rootGetters["apollo/get"].zonesList);
    }
  }

};
//# sourceMappingURL=shippingAddress.mjs.map